import { useUsers } from '../context/UserContext';
import { useParams } from 'react-router-dom';
import { useProjects } from '../context/ProjectContext';
export const useMainNavLinks = () => {
  const { user } = useUsers();
  const isAnalyst = user?.roles.some(role => role.name == 'GVE_Analyst');
  return ([
    { label: 'Dashboard', path: '/' },
    (!isAnalyst && { label: 'Admin Users', path: '/admin-users' }),
    { label: 'Project Users', path: '/project-users' },
    { label: 'Projects', path: '/projects' },
  ]).filter(Boolean);;
}

export const useProjectNavLinks = () => {
  const { projectId } = useParams();
  const { user } = useUsers();
  const { projects, isProjectReadOnly } = useProjects();
  const currentProject = projects?.find(p => String(p.id) === String(projectId));

  const permissions = user?.roles?.flatMap(role => {
    const perms = role?.permissions || {};
    return Object.entries(perms).flatMap(([section, actions]) =>
      actions.map(action => `${section}.${action}`)
    );
  }) || [];

  const hasPermission = (section, action = 'Read') => {
    if (permissions.length === 0) return true; // bypass if null, meaning admin
    return permissions.includes(`${section}.${action}`);
  }

  const isAdmin = user?.roles.some(role => role.regionIds == null);
  const isSuperAdmin = user?.roles.some(role => role.isSuper == true);
  const isAnalyst = user?.roles.some(role => role.name == 'GVE_Analyst');

  const links = [
    { label: 'GVI Morph', path: isSuperAdmin ? '/' : '#' },
    { label: 'Dashboard', path: `/projects/${projectId}/dashboard` },
    (isAdmin && !isAnalyst) && { label: 'Regions', path: `/projects/${projectId}/regions` },
    (isAdmin && !isAnalyst) && { label: 'Roles', path: `/projects/${projectId}/roles` },
    isAdmin && { label: 'Privacy Consent', path: `/projects/${projectId}/consent` },
    hasPermission('Users') && { label: 'Users', path: `/projects/${projectId}/users` },
    hasPermission('Users') && { label: 'Users Activity', path: `/projects/${projectId}/activity` },
    hasPermission('Engagements (Reports)') && { label: 'Reports', path: `/projects/${projectId}/reports` },
    hasPermission('Engagements (Reports)') && { label: 'Exports', path: `/projects/${projectId}/exports` },
  hasPermission('Engagements (Reports)') && currentProject?.settings?.validation === true && { label: 'Validation', path: `/projects/${projectId}/validation` },
    hasPermission('Stores') && { label: 'Stores', path: `/projects/${projectId}/stores` },
    (!isProjectReadOnly && isAdmin && !isAnalyst) && { label: 'Forms', path: `/projects/${projectId}/form-builder` },
    isAdmin && { label: 'Audit Logs', path: `/projects/${projectId}/audit-logs` },
  ];

  return links.filter(Boolean); // Remove falsy entries
};
